// extracted by mini-css-extract-plugin
export var chip = "_fh-0";
export var filterDropdown = "_fh-5";
export var filterItem = "_fh-6";
export var icon = "_fh-1";
export var removeButton = "_fh-3";
export var removeIcon = "_fh-4";
export var separator = "_fh-2";